import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { logger } from "@/logger";
import "antd/dist/reset.css";
import "./index.css"
import "./locales/i18n";
import { initAnalytics } from "@/libs/analytics/firebase";
import { initTracker } from "@/libs/analytics/openreplay";

const UPLOAD_SW_SCRIPT = "/upload-service-worker.js";

// Initialize Firebase Analytics
initAnalytics();

// Initialize OpenReplay session tracking
initTracker();

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    logger.debug("[main] Registering upload service worker", { scriptUrl: UPLOAD_SW_SCRIPT });
    navigator.serviceWorker
      .register(UPLOAD_SW_SCRIPT, { updateViaCache: "none" })
      .then((reg) => {
        void reg.update().catch((err) => {
          logger.warn("[main] Upload service worker update check failed", {
            error: err instanceof Error ? err.message : String(err),
          });
        });
        logger.debug("[main] Upload service worker registered", {
          scope: reg.scope,
          state: reg.active?.state ?? reg.installing?.state ?? reg.waiting?.state,
        });
        return navigator.serviceWorker.ready;
      })
      .then(() => {
        logger.debug("[main] Upload service worker ready, endpoint will be configured by Bootstrap Redux");
      })
      .catch((err) => {
        logger.warn("[main] Upload service worker failed", { error: err instanceof Error ? err.message : String(err) });
      });
  });
} else {
  logger.debug("[main] Service workers not supported, upload worker will not be registered");
}
